var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8257 0.78125L0.782227 3.70641V9.55673C0.782227 10.9651 1.19962 13.977 2.86918 16.0571C4.53875 18.1372 8.20252 20.174 9.8257 20.6073C11.9127 19.7406 13.9996 19.3073 16.7822 16.0571C18.1837 14.4202 18.5214 12.8069 18.5214 9.55673V3.70641L9.8257 0.78125Z",
    stroke: "#00CE00",
    strokeWidth: 1.56522,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2168 9.98569L8.54288 13.172L15.5646 6.44531",
    stroke: "#00CE00",
    strokeWidth: 1.56522,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.001d1450c0d5346519ff089a14622921.svg";
export { ForwardRef as ReactComponent };